
// import MTable from 'm-table'
// import MTable from '@com/pt-components/m-table/Table.vue'
import MTable from 'm-table/package/Table.vue';

export default {
  extends: MTable,
  mounted: function mounted() {
    // hidden expanded cell width
    // 隐藏第一列
    var columns = this.$refs.table.columns || [];
    var expandColumn = columns.find(function (column) {
      return column.type === 'expand';
    });
    if (expandColumn) {
      expandColumn.minWidth = 0;
      expandColumn.width = 0;
    }
  }
};